import React from 'react';
import PillLabel from '../../../components/PillLabel';

type Props = {};

export function SubscriptionManagementMessage() {
  return (
    <>
      <div className="align-bottom bg-surface rounded-lg text-left overflow-hidden  sm:my-8 sm:align-middle  mx-4 mt-4 mb-4">
        <div className="bg-tertiary-container p-4">
          <div className="">
            <div className="mx-auto flex-shrink-0 flex items-center justify-center">
              <PillLabel
                label={`Subscription Info`}
                color="bg-on-tertiary-container"
                text_color="text-tertiary-container"
              />
            </div>
            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <div className="mt-2">
                <p className="text-sm leading-5 text-on-tertiary-container text-left">
                  {`You will be able to manage your subscription digitally. You will receive a text message with a direct link, or you can click on the floating profile icon (bottom right) to view your active subscriptions & orders.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
